import { render } from "./About.vue?vue&type=template&id=b8858180&bindings={\"content\":\"setup\",\"isLoaded\":\"setup\"}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render

export default script